import merge from "lodash/merge";
import { useMemo } from "react";
// @mui
import CssBaseline from "@mui/material/CssBaseline";
import { GlobalStyles } from "@mui/material"; // 追加
import { jaJP } from "@mui/material/locale";
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
  ThemeOptions,
} from "@mui/material/styles";
// components
import { useSettingsContext } from "src/components/settings";
// system
import { palette } from "./palette";
import { shadows } from "./shadows";
import { typography } from "./typography";
import { customShadows } from "./custom-shadows";
import { componentsOverrides } from "./overrides";
// options
import { presets } from "./options/presets";
import { contrast } from "./options/contrast";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function ThemeProvider({ children }: Props) {
  const settings = useSettingsContext();

  const presetsOption = presets(settings.themeColorPresets);

  const contrastOption = contrast(
    settings.themeContrast === "bold",
    settings.themeMode
  );

  const baseOption = useMemo(
    () => ({
      palette: palette("light"),
      shadows: shadows("light"),
      customShadows: customShadows("light"),
      typography,
      shape: { borderRadius: 8 },
    }),
    []
  );

  const memoizedValue = useMemo(
    () =>
      merge(
        // Base
        baseOption,
        // Presets: remove if not in use
        presetsOption,
        // Contrast: remove if not in use
        contrastOption.theme
      ),
    [baseOption, presetsOption, contrastOption.theme]
  );

  const baseTheme = createTheme(memoizedValue as ThemeOptions);

  baseTheme.components = merge(
    componentsOverrides(baseTheme),
    contrastOption.components
  );

  const theme = createTheme(baseTheme, jaJP);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {/* 背景色の設定のみ追加 */}
      <GlobalStyles
        styles={{
          html: {
            backgroundColor: "#ffffff !important",
          },
        }}
      />
      {children}
    </MuiThemeProvider>
  );
}
